'use strict';
exports.default = exports;

const {UserType} = require('../status');
// const gql = require('graphql-tag').gql;
const BaseEntity = require('./BaseEntity.js').BaseEntity;
// const moment = require('moment');




/**
 * @typedef {import('../status').UserBoardType} UserBoardType
 */


/**
 @typedef {keyof UserBoardType} UserBoardType
 */

/**
 @typedef {object} UserBoardInfo
 @property {string} boardNumber - antigo d.crm.
 @property {string} region - antigo d.crmState.
 @property {boolean} active - .
 @property {keyof UserBoardType} boardType - antigo d.crmState.
 */


class CompanyUserEntity extends BaseEntity {
  active = true;
  hasAccess = true;
  hasAccessFiliais = true;
  // companyId = '';
  attachments = {};
  attachmentsOthers = {};
  customFields = {};
  financial = {};
  // userBoardInfoIds = {};
  acronym = '';
  profilesIds = [];
  filiaisIds = [];
  allFiliais = false; // Ainda não usado
  filiaisProfiles = {};
  /**
   * @type {UserBoardInfo[]}
   */
  userBoardInfos = [];
  type = ''; // Old UserType
  accessibleUsersIds = [];  // Old accessibleUsers
  teamTypes = [];

  /**
   *
   * @param {CompanyUserEntity|object?} obj
   */
  constructor(obj) {
    super(obj);
    this.setFcm(obj);
  }

  example() {
    this.setFcm({
    });
    return this;
  }

  getFullMutation(key = 'id') {
    if (!this.batchesIds) {
      this.batchesIds = [];
    }
    return super.getFullMutation(key);
  }
}

CompanyUserEntity._defaults = new CompanyUserEntity();

const newCompanyUser = {
  active: true,
  hasAccessFiliais: true,
  hasAccess: true,
};

const defaultCompanyUser = {
  active: true,
  profilesIds: [],
  type: UserType.KUSER,
  hasAccessFiliais: true,
  hasAccess: false,
  userBoardInfos: [],
  accessibleUsersIds: [],
  acronym: '',
  financial: {},
  customFields: {},
  attachments: {},
  attachmentsOthers: {},
  filiaisProfiles: {},
};


// const CompanyUserFragment = gql`
//   fragment CompanyUserFragment on CompanyUser {
//     active
//     id
//   }
// `;

exports.CompanyUserEntity = CompanyUserEntity;
exports['defaultCompanyUser'] = defaultCompanyUser;
exports['newCompanyUser'] = newCompanyUser;
// exports.CompanyUserFragment = CompanyUserFragment;




